import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { theme, prop, switchProp } from 'styled-tools';

interface PageHeadlineProps {
  color?: string;
  lg?: number;
  fontUnit?: number;
  lhLg?: number;
  md?: number;
  lhMd?: number;
  sm?: number;
  lhSm?: number;
  xs?: number;
  lhXs?: number;
}

const PageHeadline = styled.h1<PageHeadlineProps>`
  color: ${switchProp(prop('color', 'blue'), {
    blue: theme('colors.blue'),
    white: theme('colors.white'),
  })};
  font-weight: bold;
  font-size: ${prop('lg', 80)}${prop('fontUnit', 'px')};
  line-height: ${prop('lhLg', '1em')};
  ${breakpoint('md', 'lg')`
    font-size: ${prop('md', 80)}${prop('fontUnit', 'px')}
    line-height: ${prop('lhMd', '1em')};
  `}
  ${breakpoint('sm', 'md')`
    font-size: ${prop('sm', 72)}${prop('fontUnit', 'px')}
    line-height: ${prop('lhSm', '1em')};
  `}
  ${breakpoint('xs', 'sm')`
    font-size: ${prop('xs', 40)}${prop('fontUnit', 'px')}
    line-height: ${prop('lhXs', '1em')};
  `}
`;

export default PageHeadline;
